<template>
    <figure class="flex flex-col gap-4">
        <div class="flex items-center justify-center gap-[10px]">
            <v-icon icon="location-home"></v-icon>
            <div class="text-body-medium-button text-black-78">Naslov</div>
        </div>
        <ul class="flex flex-col gap-8">
            <li>
                <v-form-input
                    id="userAddress"
                    label="Ulica"
                    type="text"
                    name="street"
                    :value="this.old.street ? this.old.street : user.street"
                ></v-form-input>
                <template v-if="validationErrors.street">
                    <label class="small-text-medium text-red-500">{{
                        validationErrors.street[0] ?? ""
                    }}</label>
                </template>
            </li>
            <li>
                <v-form-input
                    id="userAddressNumber"
                    label="Hišna številka"
                    type="text"
                    name="house_number"
                    :value="this.old.house_number ? this.old.house_number : user.house_number"
                ></v-form-input>
                <template v-if="validationErrors.house_number">
                    <label class="small-text-medium text-red-500">{{
                        validationErrors.house_number[0] ?? ""
                    }}</label>
                </template>
            </li>
            <li>
                <v-form-input
                    id="userAddressPostal"
                    label="Poštna številka"
                    type="text"
                    name="post_number"
                    :value="this.old.post_number ? this.old.post_number : user.post_number"
                ></v-form-input>
                <template v-if="validationErrors.post_number">
                    <label class="small-text-medium text-red-500">{{
                        validationErrors.post_number[0] ?? ""
                    }}</label>
                </template>
            </li>
            <li>
                <v-form-input
                    id="userCity"
                    label="Kraj"
                    type="text"
                    name="location"
                    :value="this.old.location ? this.old.location : user.location"
                ></v-form-input>
                <template v-if="validationErrors.location">
                    <label class="small-text-medium text-red-500">{{
                        validationErrors.location[0] ?? ""
                    }}</label>
                </template>
            </li>
            <li>
                <v-select
                    class="v-select--xs w-full appearance-none rounded-full border-0 p-0 font-medium text-black-78 ring-1 ring-inset ring-gray placeholder:text-black-40 focus-within:ring-2 focus-within:ring-green"
                    :options="customerFormEnums.country"
                    placeholder="Država"
                    v-model="customerCountry"
                    label="label"
                    ref="country"
                    id="country"
                    :name="'country'"
                >
                    <template v-slot:no-options>
                        Za ta iskalni niz ni zadetkov.
                    </template>
                </v-select>
                <input
                    type="hidden"
                    name="country"
                    :value="
                        customerCountry == null ? '' : customerCountry.value
                    "
                />
                <template v-if="validationErrors.country">
                    <label class="small-text-medium text-red-500">{{
                        validationErrors.country[0] ?? ""
                    }}</label>
                </template>
            </li>
        </ul>
    </figure>
</template>

<script>
export default {
    props: {
        user: {
            type: Object,
            required: true,
        },
        old: {
            type: Object,
            required: true,
        },
        customerFormEnums: {
            type: Object,
            required: true,
        },
        validationErrors: {
            type: Object,
            required: true,
        },
    },
    data() {
        return {
            customerCountry: null,
        };
    },
    mounted() {
        this.customerFormEnums.country.forEach((element) => {
            if(this.old && 'country' in this.old)
            {
                if(element.value == this.old.country) {
                    this.customerCountry = element
                }
            } else {
                if(element.value == this.user.country) {
                    this.customerCountry = element
                }
            }
        })
    },
};
</script>
